module.exports = __webpack_public_path__ + "img/logo-dark.73dd1a5b.png";